import { ComponentProps, ReactNode } from "react";

function createIcon(path: ReactNode, viewBox: string = "0 0 24 24") {
  return function Icon(props: ComponentProps<"svg">) {
    return (
      <svg
        viewBox={viewBox}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...props}
      >
        {path}
      </svg>
    );
  };
}

export const SampleIcon = createIcon(
  <g>
    <g>
      <path d="M15.3,10.47c.42.07,1.01,1.02,1.42,1.1.15.03.25.11.31.26.18.44.37.88.56,1.32.01.03.03.06.04.08v.19c-.09.18-.25.23-.44.23" />
      <path d="M13.46,8.96c.59.09,1.42,1.11,1.84,1.51-.34-.01-1.18,1.01-1.44,1.16" />
      <path d="M7.75,10.53c.78-.72,1.27-2.28,2.48-2.59" />
      <path d="M6.98,13.65c-.28,0-.47-.19-.38-.49.19-.65.36-1.31.54-1.97.1-.29.4-.44.6-.66.24.21,1.72.86,1.91,1.1" />
      <path d="M10.23,7.95c1.51-1.35,2.54-.32,3.23,1.02-.95-.33-1.43,1.15-2.1,1.35" />
    </g>
    <polyline points="3.5 11.63 4.98 16.06 19.02 16.06 20.5 11.63" />
    <line x1="6.98" y1="13.65" x2="17.19" y2="13.65" />
  </g>,
  "2 6.5 20 11",
);

export {
  Layers as HomeIcon,
  LayoutDashboard as DashboardIcon,
  Users as UsersIcon,
  Cable as IntegrationsIcon,
  ShieldCheck as AdminIcon,
  Building2 as LocationsIcon,
  Stone as AggregatesIcon,
  ClipboardList as ReportsIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  CreditCard as CreditCardIcon,
  FileText as DocumentTextIcon,
  PencilRuler as SpecificationsIcon,
  BookOpenCheck as ProceduresIcon,
  FlaskConical as LabsIcon,
} from "lucide-react";
